import React from 'react';
import PropTypes from 'prop-types';

export default function DateRangeCalendarPlaceholder(props) {
    return (
        <div className="DateRangePicker DateRangePicker_1">
            <div className="DateRangePickerInput DateRangePickerInput_1">
                <div className="DateInput DateInput_1">
                    <input
                        type="text"
                        className="DateInput_input DateInput_input_1"
                        aria-label={props.startPlaceholder}
                        id={props.startId}
                        name={props.startId}
                        value={props.startDate || ''}
                        placeholder={props.startPlaceholder}
                        autoComplete="off"
                        readOnly
                        aria-describedby="DateInput__screen-reader-message-date-range-start"
                    />
                    <p
                        className="DateInput_screenReaderMessage DateInput_screenReaderMessage_1"
                        id="DateInput__screen-reader-message-date-range-start">
                        Trykk på ned-tasten for å endre kalenderen og velge en dato. Trykk på spørsmålstegn-tasten for å se flere snarveier
                        for endring av dato.
                    </p>
                </div>
                <div className="DateInput DateInput_1">
                    <input
                        type="text"
                        className="DateInput_input DateInput_input_1"
                        aria-label={props.endPlaceholder}
                        id={props.endId}
                        name={props.endId}
                        value={props.endDate || ''}
                        placeholder={props.endPlaceholder}
                        autoComplete="off"
                        readOnly
                        aria-describedby="DateInput__screen-reader-message-date-range-end"
                    />
                    <p
                        className="DateInput_screenReaderMessage DateInput_screenReaderMessage_1"
                        id="DateInput__screen-reader-message-date-range-end">
                        Trykk på ned-tasten for å endre kalenderen og velge en dato. Trykk på spørsmålstegn-tasten for å se flere snarveier
                        for endring av dato.
                    </p>
                </div>
            </div>
        </div>
    );
}

DateRangeCalendarPlaceholder.propTypes = {
    startId: PropTypes.string.isRequired,
    endId: PropTypes.string.isRequired,
    startPlaceholder: PropTypes.string.isRequired,
    endPlaceholder: PropTypes.string.isRequired,
    startDate: PropTypes.string,
    endDate: PropTypes.string,
};
